export default __webpack_public_path__ + "static/media/HardwareFree Right.3cebf373.png";